var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnvelopeSimple(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "EnvelopeSimple"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.2,
    d: "M21 5.64844L12 13.8984L3 5.64844H21Z",
    fill: "#F07300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3 5.64844H21V18.3984C21 18.5973 20.921 18.7881 20.7803 18.9288C20.6397 19.0694 20.4489 19.1484 20.25 19.1484H3.75C3.55109 19.1484 3.36032 19.0694 3.21967 18.9288C3.07902 18.7881 3 18.5973 3 18.3984V5.64844Z",
    stroke: "#F07300",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M21 5.64844L12 13.8984L3 5.64844",
    stroke: "#F07300",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopeSimple);
export default __webpack_public_path__ + "static/media/EnvelopeSimple.87166e92aabc015a3c2b0d5cafe3dfa5.svg";
export { ForwardRef as ReactComponent };